import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { GetAllTypes } from "../../../states/Item/item.actions";
import { select, Store } from "@ngrx/store";
import { ItemSelector } from "../../../states/Item/item.selectors";
import { NavigationEnd, Router } from '@angular/router';
import { FOOTER_CONFIG } from "../../../shared/interfaces";
import { TitleMetaService } from '../../services/title-meta.service';

const Horizontal = 'horizontal';

@Component({
	selector: 'app-nav-bar',
	templateUrl: './nav-bar.component.html',
	styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
	public occasions: any[] = [];
	public menus: any = { menuJewellery: false, menuOccassion: false, menuOthers: false };
	public footerConfig = FOOTER_CONFIG;
	public jMenuOptions: any[] = [];
	public others: any[] = [];
	public isMobileMenuVisible: boolean = true;
	private previousScrollTop = 0;
	private footerOffset = 100;
	public finalName: string

	constructor(
		private store: Store,
		private router: Router,
		private eRef: ElementRef,
		private titleMetaService: TitleMetaService
	) {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (event?.url.includes('items')) {
					let val = event?.url?.split("=")
					const str = val[0].split('/')[2]
					const nameWithoutSuffix = str.replace('-jewellery', '');
					this.finalName = nameWithoutSuffix.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
					const metaTags = this.getMetaTagsForOccasion(this.finalName);
					this.updateMetaTags(metaTags);
				}
			}
		});
	}

	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this.eRef.nativeElement.contains(event.target)) {
			this.menus = {};
		}
	}

	ngOnInit(): void {
		this.subscribeToTypes();
		this.previousScrollTop = window.scrollY || document.documentElement.scrollTop;
	}

	navigate(key: string, name: string = '', value: string = "", submenu: any = null) {
		this.menus = {};
		localStorage.removeItem('ItemPage');
		if (submenu?.thresh) {
			// this.router.navigate(['items'], {
			// 	queryParams:
			// 	{
			// 		[value]: submenu.thresh,
			// 	}
			// })
			if (key === "collectionTypes") {
				this.router.navigate(['collection', name], {
					state:
					{
						[value]: submenu.thresh,
					}
				})
			} else if (key === "productType") {
				this.router.navigate(['product', name], {
					state:
					{
						[value]: submenu.thresh,
					}
				})
			} else {
				this.router.navigate(['items', name], {
					state:
					{
						[value]: submenu.thresh,
					}
				})
				// .then(() => {
				// 	window.location.reload()
				// })
			}
		} else {
			// this.router.navigate(['items'], { queryParams: { [key]: value } })
			if (key === "collectionTypes") {
				this.router.navigate(['collection', name], { state: { [key]: value } })
			} else if (key === "productType") {
				this.router.navigate(['product', name], { state: { [key]: value } })
			} else {
				this.router.navigate(['items', name], { state: { [key]: value } })
				// .then(() => {
				// 	window.location.reload()
				// })
			}

		}
	}

	occasionsName(name: string): string {
		return `${name.trim().toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}-jewellery`;
	}

	JewelleryName(name: string, key: string): string {
		if (key === "occassionTypes") {
			return `${name.trim().toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}-jewellery`;
		} else {
			return `${name.trim().toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}`;
		}
	}

	getMetaTagsForOccasion(occasion: string) {
		let metaTagMap: any = {};
		let occasionName = ''
		for (const occ of this.occasions) {
			// if (occ?.id === occasion) {
			if (occasion === occ?.name) {
				occasionName = occ?.name
				if (occ?.name === "Casual Wear") {
					metaTagMap = {
						"Casual Wear": {
							title: "Best Casual Wear Gold Jewellery Online in India - Ausmit",
							description: "Elevate your casual style with Ausmit's exquisite collection of gold Jewellery. Shop online for the finest selection of versatile pieces to complement any outfit effortlessly.",
							keywords: "casual wear gold Jewellery, best casual wear Jewellery, buy casual wear gold Jewellery online",
						},
					};
				} else if (occ?.name === "Modern") {
					metaTagMap = {
						"Modern": {
							title: "Buy Modern Gold Jewellery Online in India - Ausmit",
							description: "Be stylish with our modern gold Jewellery designs, available for purchase online in India. Explore now and find the perfect statement piece to adorn your look.",
							keywords: "modern gold jewellery India, modern gold Jewellery online, get modern gold Jewellery online, best gold Jewellery online India",
						},
					};
				} else if (occ?.name === "General") {
					metaTagMap = {
						"General": {
							title: "Explore Exquisite Gold Jewellery Online India - Ausmit",
							description: "Buy general gold Jewellery and add a touch of elegance to any ensemble. Shop now and indulge in the luxury of fine craftsmanship with Ausmit.",
							keywords: "general gold Jewellery online, best general gold Jewellery, general gold jewellery India",
						},
					};
				} else if (occ?.name === "Festival") {
					metaTagMap = {
						"Festival": {
							title: "Explore Gold Jewellery Online in India for Festivals - Ausmit",
							description: "Shop online and adorn yourself with the shimmering beauty of Ausmit's festival gold Jewellery. Our exquisite designs come with contemporary elegance, so get ready to buy.",
							keywords: "gold Jewellery for festivals, festival gold jewellery India, best festival gold Jewellery",
						},
					};
				} else if (occ?.name === "Party") {
					metaTagMap = {
						"Party": {
							title: "Shop Party Wear Gold Jewellery Online - Ausmit",
							description: "Raise your party with our dazzling collection of gold Jewellery, meticulously crafted to add sparkle to every occasion. Shop online and make a statement with Ausmit's party wear gold Jewellery.",
							keywords: "party wear gold Jewellery, buy party wear gold Jewellery, party wear Jewellery online",
						},
					};
				} else if (occ?.name === "Office wear") {
					metaTagMap = {
						"Office wear": {
							title: "Get Office Wear Gold Jewellery Collection Online India - Ausmit",
							description: "Explore our range of elegant pieces crafted for everyday wear in office. Shop now and enhance your style effortlessly with Ausmit's office wear gold Jewellery.",
							keywords: "office wear gold Jewellery, office wear gold Jewellery online, buy office wear gold Jewellery",
						},
					};
				} else if (occ?.name === "Weddings") {
					metaTagMap = {
						"Weddings": {
							title: "Best Wedding Gold Jewellery Collection - Ausmit",
							description: "Buy now and add a touch of radiance to your wedding ensemble with Ausmit's finest gold Jewellery pieces.",
							keywords: "wedding wear gold Jewellery, wedding wear gold Jewellery online",
						},
					};
				} else if (occ?.name === "Gift") {
					metaTagMap = {
						"Gift": {
							title: "Gift and Shine Bright with Gold Jewellery Online - Ausmit",
							description: "From timeless designs to contemporary pieces, our selection offers something for every occasion. Shop now at Ausmit and give the best gift to your near and dear ones.",
							keywords: "gift gold Jewellery online, gift gold jewellery India",
						},
					};
				} else if (occ?.name === "Daily") {
					metaTagMap = {
						"Daily": {
							title: "Daily Wear Gold Jewellery Online India - Ausmit",
							description: "Elevate your daily style with our versatile collection of gold Jewellery, curated for everyday wear. Discover timeless designs crafted to complement your unique flair effortlessly. Shop now and add a touch of elegance to every moment with Ausmit's daily wear gold Jewellery.",
							keywords: "daily wear gold Jewellery, daily wear gold jewellery India, best daily wear Jewellery",
						},
					};
				} else if (occ?.name === "Date") {
					metaTagMap = {
						"Date": {
							title: "Buy Best Gold Jewellery for Special Dates - Ausmit",
							description: "Buy best gold Jewellery for special dates, designed to add a touch of romance to every moment. We, at Ausmit offers you best for your date.",
							keywords: "special dates gold Jewellery, special date gold Jewellery online",
						},
					};
				}
			}
			// }
		}

		return (
			metaTagMap[occasionName] || {
				title: 'Shop Jewellery - Ausmit',
				description: 'Explore a wide range of jewellery at Ausmit. Perfect for every occasion.',
				keywords: 'jewellery, shop jewellery, Ausmit jewellery',
			}
		);
	}

	updateMetaTags(metaTags: { title: string; description: string; keywords: string }) {
		this.titleMetaService.setTitle(metaTags.title);
		this.titleMetaService.setMetaDescription(metaTags.description);
		this.titleMetaService.setMetaKeywords(metaTags.keywords);
	}

	removeStorePage() {
		localStorage.removeItem('StorePage')
	}

	private subscribeToTypes() {
		this.store.pipe(
			select(ItemSelector.selectTypesListData),
		).subscribe(typesListData => {
			if (!typesListData) {
				this.store.dispatch(new GetAllTypes());
			} else {
				if (!this.jMenuOptions.length) {
					this.jMenuOptions.push({
						title: 'Gender', key: 'gender', options: [
							{ name: 'Women', id: 'Women' },
							{ name: 'Men', id: 'Men' },
							{ name: 'Kids', id: 'Kids' },
							{ name: 'UniSex', id: 'UniSex' }
						]
					});

					this.jMenuOptions.push({
						title: 'Metal', key: 'metal', options: [
							// { name: 'Gold', id: 'variant.primaryMetal.purity', thresh: ['GOLD_22', 'GOLD_24', 'GOLD_18'] },
							// { name: 'Silver', id: 'variant.primaryMetal.purity', thresh: ['SILVER'] },
							// { name: 'Diamond', id: 'variant.diamond.count', thresh: '0' },
							// { name: 'Platinum', id: 'variant.primaryMetal.purity', thresh: ['PLATINUM'] }
							{ name: 'Gold', id: 'primaryMetal.purity', thresh: ['GOLD_22', 'GOLD_24', 'GOLD_18'] },
							{ name: 'Silver', id: 'primaryMetal.purity', thresh: ['SILVER'] },
							{ name: 'Diamond', id: 'diamondType', thresh: 'NATURAL' },
							{ name: 'Diamond Cvd', id: 'diamondType', thresh: 'LAB GROWN' },
							{ name: 'Platinum', id: 'primaryMetal.purity', thresh: ['PLATINUM'] }
						]
					})

					if (typesListData?.occasions) {
						this.occasions = typesListData?.occasions;

						this.jMenuOptions.push({
							title: 'Occassion',
							key: 'occassionTypes',
							options: typesListData?.occasions
						});
					}

					if (typesListData?.collectionTypes) {
						this.jMenuOptions.push({
							title: 'Collection',
							key: 'collectionTypes',
							options: typesListData?.collectionTypes
						});
					}

					if (typesListData?.itemTypes) {
						this.jMenuOptions.push({
							title: 'Item',
							key: 'itemType',
							options: typesListData?.itemTypes
						});
					}

					if (typesListData?.productTypes) {
						const productTypes: any[] = [];
						const others: any[] = [];
						typesListData?.productTypes.map((item) => {
							if (item?.itemType?.name === 'Jewellery') {
								productTypes.push(item);
							} else if (item?.itemType?.name === 'Article') {
								others.push(item)
							}
						});

						if (productTypes.length) {
							this.jMenuOptions.push({
								title: 'Product',
								key: 'productType',
								options: productTypes
							});
						}

						if (others.length) {
							others.forEach(item => {
								this.others.push({
									title: item?.name,
									key: 'productTypeRange',
									options: item?.range
								})
							})
						}
					}
				}
			}
		});
	}

	@HostListener('window:scroll', ['$event'])
	onWindowScroll() {
		const scrollTop = window.scrollY || document.documentElement.scrollTop;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		if (documentHeight <= windowHeight) {
			this.isMobileMenuVisible = true;
			return;
		}
		const isNearBottom = (scrollTop + windowHeight) >= (documentHeight - this.footerOffset);
		const isScrollingDown = scrollTop > this.previousScrollTop;
		this.previousScrollTop = scrollTop;
		if (isScrollingDown && isNearBottom) {
			this.isMobileMenuVisible = false;
		} else if (!isScrollingDown || !isNearBottom) {
			this.isMobileMenuVisible = true;
		}
	}
}
